import { BaseAPIModel } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';

/**
 * Represents a SeatInventory object
 * @constructor
 */
export function SeatInventory({ access, active_booking: activeBooking, booking_state: bookingState, category, contingent, label, row, seat, uuid, x, y, zone }) {
    let that = {};
    that.id = () => uuid;
    that.activeBooking = () => activeBooking;
    that.category = () => category;
    that.contingent = () => contingent;
    that.bookingState = () => bookingState;
    // that.inventory = () => inventory;
    that.seat = () => seat;

    return that;
}

export class Seat extends BaseAPIModel {
    fields() {
        return {
            uuid: { primaryKey: true }
        };
    }

    static listUrl({ organizationId, chartId, zoneId }) {
        if (!organizationId || !chartId || !zoneId) {
            throw new ArgumentError('[Model][Seat][get] chartId and zoneId are mandatory');
        }

        return `/ticket/organizations/${organizationId}/charts/${chartId}/zones/${zoneId}/seats`;
    }
}
